module.exports = __webpack_public_path__ + "static/media/SF-18-A (1).a1dfd886.mp3";